/* ============================================================
   Bundle PDP — 3-step bundle builder
   Step 1 pick a product · Step 2 pick its shade · Step 3 pick a palette.
   Drives the native gallery (image swap + Section Rendering API re-render).
   Cart: when the chosen foundation has a native bundle product, the chosen
   shade + palette resolve to one bundle variant added as a single line item;
   that variant also drives the header price (bundle price + crossed-out RRP).
   With no bundle assigned it falls back to the legacy two-line add.
   ============================================================ */

(function () {
  'use strict';

  var root = document.querySelector('[data-bsp-bundle]');
  if (!root) return;

  var syncPrice = root.getAttribute('data-sync-price') !== 'false';
  var syncProductInfo = root.getAttribute('data-sync-product-info') !== 'false';
  var stepsExpandedMobile = root.getAttribute('data-steps-expanded-mobile') === 'true';
  var stepsExpandedDesktop = root.getAttribute('data-steps-expanded-desktop') === 'true';
  var stepsExpanded = window.innerWidth >= 768 ? stepsExpandedDesktop : stepsExpandedMobile;
  var moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';

  var state = {
    productKey: null,
    productHandle: null,
    productPriceCents: 0,
    shadeVariantId: null,
    shadeCode: null,
    paletteVariantId: null,
    paletteTitle: null,
    palettePriceCents: 0,
    bundleVariant: null,
    bundleFromPrice: 0,
    bundleFromCompare: 0,
  };

  /* Native bundle variants per Step 1 card, indexed both option orders so a
     chosen shade + palette resolves regardless of which option holds which.
     Keys are normalised (trimmed, lower-cased) and joined by a rare separator. */
  var SEP = '~~';
  function norm(s) { return (s == null ? '' : String(s)).trim().toLowerCase(); }

  var bundleIndex = {};
  (function parseBundleMap() {
    var el = root.querySelector('[data-bsp-bundle-map]');
    if (!el) return;
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return; }
    Object.keys(data).forEach(function (k) {
      var idx = {};
      (data[k] || []).forEach(function (v) {
        idx[norm(v.o1) + SEP + norm(v.o2)] = v;
        idx[norm(v.o2) + SEP + norm(v.o1)] = v;
      });
      bundleIndex[k] = idx;
    });
  })();

  function productHasBundle(key) { return !!(key && bundleIndex[key]); }

  function resolveBundle() {
    state.bundleVariant = null;
    var idx = bundleIndex[state.productKey];
    if (!idx || !state.shadeCode || !state.paletteTitle) return;
    state.bundleVariant = idx[norm(state.shadeCode) + SEP + norm(state.paletteTitle)] || null;
  }

  /* ── DOM refs ──────────────────────────────────────────── */
  var stepEls = root.querySelectorAll('[data-bsp-step]');
  var toggleBtns = root.querySelectorAll('[data-bsp-toggle]');
  var finishCards = root.querySelectorAll('[data-finish-card]');
  var shadeGroups = root.querySelectorAll('[data-shade-product]');
  var shadeDescEl = root.querySelector('[data-bsp-shade-desc]');
  var shadeDescTxt = root.querySelector('.bundle__shade-desc--text');
  var atcBtn = root.querySelector('[data-bsp-atc]');
  var atcTextEl = root.querySelector('[data-bsp-atc-text]');
  var errorEl = root.querySelector('[data-bsp-error]');
  var qtyInput = root.querySelector('[data-bsp-qty]');
  var favEl = root.querySelector('[data-bsp-fav-wrapper] .t4s-pr-wishlist');

  var labels = {
    ready: atcBtn.getAttribute('data-label-ready'),
    step: atcBtn.getAttribute('data-label-step'),
    adding: atcBtn.getAttribute('data-label-adding'),
    added: atcBtn.getAttribute('data-label-added'),
    unavailable: atcBtn.getAttribute('data-label-unavailable'),
  };

  /* Product section context for the gallery + Section Rendering API. */
  var sectionEl = root.closest('[id^="shopify-section-"]');
  var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : null;
  var mediaWrapperSel = '.t4s-product__media-wrapper';
  var galleryCache = {};

  /* ── Helpers ───────────────────────────────────────────── */
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, (cents / 100).toFixed(2));
  }

  function getQty() {
    var q = parseInt(qtyInput && qtyInput.value, 10);
    return q && q > 0 ? q : 1;
  }

  /* ── Accordion ───────────────────────────────────────── */
  function setStepOpen(n, on) {
    var step = root.querySelector('[data-bsp-step="' + n + '"]');
    if (!step) return;
    var hdr = step.querySelector('[data-bsp-toggle]');
    step.classList.toggle('bundle__step--open', on);
    if (hdr) hdr.setAttribute('aria-expanded', on ? 'true' : 'false');
  }

  function openStep(n) {
    stepEls.forEach(function (step) {
      var i = parseInt(step.getAttribute('data-bsp-step'), 10);
      setStepOpen(i, i === n);
    });
  }

  if (!stepsExpanded) {
    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = parseInt(btn.getAttribute('data-bsp-toggle'), 10);
        var step = root.querySelector('[data-bsp-step="' + n + '"]');
        if (step && step.classList.contains('bundle__step--open')) setStepOpen(n, false);
        else openStep(n);
      });
    });
  } else {
    toggleBtns.forEach(function (btn) {
      btn.style.cursor = 'default';
    });
  }

  /* ── Gallery ───────────────────────────────────────────── */
  function setGalleryImage(url) {
    if (!url || !sectionEl) return;
    var media = sectionEl.querySelector('[data-main-media]') || sectionEl.querySelector(mediaWrapperSel);
    if (!media) return;
    var slide = media.querySelector('[data-main-slide]:not(.is--media-hide) img') || media.querySelector('img');
    if (!slide) return;
    slide.setAttribute('src', url);
    slide.setAttribute('data-src', url);
    slide.setAttribute('data-master', url.split('?')[0]);
    slide.removeAttribute('srcset');
    slide.removeAttribute('data-srcset');
    slide.classList.add('lazyloadt4sed');
    slide.classList.remove('lazyloadt4s');
  }

  /* Re-render a product's gallery via the Section Rendering API. A monotonic
     request id + AbortController stop a slow older fetch from overwriting a
     newer choice. */
  var galleryRequestId = 0;
  var galleryFetchAbort = null;
  function isCurrent(id) { return id === galleryRequestId; }

  function renderProductGallery(handle) {
    if (!sectionEl || !sectionId || !handle) return;
    var current = sectionEl.querySelector(mediaWrapperSel);
    if (!current) return;

    var requestId = ++galleryRequestId;
    if (galleryFetchAbort) galleryFetchAbort.abort();

    if (galleryCache[handle]) {
      current.outerHTML = galleryCache[handle];
      afterGallerySwap(requestId);
      return;
    }

    galleryFetchAbort = new AbortController();
    fetch('/products/' + handle + '?section_id=' + encodeURIComponent(sectionId), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: galleryFetchAbort.signal,
    })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        if (!isCurrent(requestId)) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(mediaWrapperSel);
        var live = sectionEl.querySelector(mediaWrapperSel);
        if (!fresh || !live) return;
        galleryCache[handle] = fresh.outerHTML;
        live.outerHTML = fresh.outerHTML;
        afterGallerySwap(requestId);
      })
      .catch(function (err) { if (!err || err.name !== 'AbortError') { /* image already swapped */ } });
  }

  /* The injected markup carries the theme's "initialised" flags but no live
     carousel — strip them so the theme rebuilds the carousel + thumbnails. */
  function afterGallerySwap(requestId) {
    if (!isCurrent(requestId)) return;
    var gal = sectionEl.querySelector('[data-flickityt4s-js]');
    if (gal) gal.classList.remove('flickityt4s-enabled', 't4s-enabled', 'is-draggable');
    try {
      if (window.T4SThemeSP && typeof window.T4SThemeSP.initCarousel === 'function') {
        window.T4SThemeSP.initCarousel();
      } else {
        document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: sectionId } }));
      }
    } catch (e) { /* theme not ready */ }
    setTimeout(function () {
      if (!isCurrent(requestId)) return;
      window.dispatchEvent(new Event('resize'));
      if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.checkElems();
    }, 60);
  }

  /* ── Header title + description sync ──────────────────── */
  function syncProductInfoBlock(title, shortDesc) {
    if (!syncProductInfo || !sectionEl) return;
    var titleEl = sectionEl.querySelector('.t4s-product__title');
    if (titleEl) {
      var h = titleEl.querySelector('h1, h2') || titleEl;
      h.textContent = title;
    }
    var descEl = sectionEl.querySelector('.short-desc');
    if (descEl) descEl.innerHTML = shortDesc || '';
  }

  /* ── Header price + wishlist sync ──────────────────────── */
  function priceTarget() {
    if (!sectionEl) return null;
    return sectionEl.querySelector('.t4s-product__price [data-product-price]') ||
           sectionEl.querySelector('.t4s-product__price .t4s-product-price') ||
           sectionEl.querySelector('.t4s-product__price');
  }

  function updatePrice() {
    var target = priceTarget();
    if (!target) return;

    /* Bundle mode. Once a shade + palette resolve to a specific variant, that
       variant is authoritative; before then, show the bundle's flat from-price
       picked up on product select. The crossed-out RRP is the variant/bundle
       compare-at when set, else (only once a variant is chosen) the summed
       foundation + palette price. */
    var bv = state.bundleVariant;
    var price = bv ? bv.price : state.bundleFromPrice;
    if (price) {
      var compare = bv ? bv.compareAt : state.bundleFromCompare;
      var rrp = compare > price
        ? compare
        : (bv ? (state.productPriceCents + state.palettePriceCents) : 0);
      var html = '<span class="bundle__price-current">' + formatMoney(price) + '</span>';
      if (rrp > price) html += ' <s class="bundle__price-rrp">' + formatMoney(rrp) + '</s>';
      target.innerHTML = html;
      return;
    }

    /* Legacy combined-price display (no bundle assigned for this foundation). */
    if (!syncPrice) return;
    var total = state.productPriceCents + state.palettePriceCents;
    if (!total) return;
    target.innerHTML = formatMoney(total);
  }

  function syncWishlist(handle, productId) {
    if (!favEl || !handle) return;
    favEl.setAttribute('data-handle', handle);
    favEl.setAttribute('href', '/products/' + handle);
    if (!productId) return;
    favEl.setAttribute('data-id', productId);
    /* The theme's wishlist JS reads data-id via jQuery .data() (cached on first
       read) — update the cache too so it favourites the selected product. */
    if (window.jQuery) window.jQuery(favEl).data('id', productId).data('handle', handle);
  }

  /* ── ATC button state ──────────────────────────────────── */
  function stepsDone() {
    return (state.productKey ? 1 : 0) + (state.shadeVariantId ? 1 : 0) + (state.paletteVariantId ? 1 : 0);
  }

  /* All three chosen and — in bundle mode — the combo resolves to an available
     bundle variant. */
  function isComplete() {
    if (!state.productKey || !state.shadeVariantId || !state.paletteVariantId) return false;
    if (productHasBundle(state.productKey)) {
      return !!(state.bundleVariant && state.bundleVariant.available);
    }
    return true;
  }

  function showError(msg) {
    if (!errorEl) return;
    if (msg) {
      errorEl.textContent = msg;
      errorEl.classList.add('bundle__error--visible');
    } else {
      errorEl.classList.remove('bundle__error--visible');
    }
  }

  function updateAtc() {
    if (!atcBtn) return;
    var complete = isComplete();
    atcBtn.disabled = !complete;
    if (atcTextEl) {
      atcTextEl.innerHTML = complete
        ? labels.ready
        : labels.step.replace('[step]', '<br>' + (stepsDone() + 1));
    }

    /* Both chosen but the bundle combo is missing/sold out → tell the customer. */
    if (!complete && state.shadeVariantId && state.paletteVariantId && productHasBundle(state.productKey)) {
      showError((labels.unavailable || 'This shade and palette combination is unavailable.'));
    } else {
      showError('');
    }
  }

  /* ── Step 1: product ───────────────────────────────────── */
  function selectFinishCard(card, advance) {
    var key = card.getAttribute('data-finish-card');
    finishCards.forEach(function (c) { c.classList.remove('bundle__finish-card--active'); });
    card.classList.add('bundle__finish-card--active');

    if (state.productKey !== key) resetShade();
    state.productKey = key;
    state.productHandle = card.getAttribute('data-finish-handle');
    state.productPriceCents = parseInt(card.getAttribute('data-finish-price-cents'), 10) || 0;
    state.bundleFromPrice = parseInt(card.getAttribute('data-bundle-from-price'), 10) || 0;
    state.bundleFromCompare = parseInt(card.getAttribute('data-bundle-from-compare'), 10) || 0;

    shadeGroups.forEach(function (g) {
      g.style.display = g.getAttribute('data-shade-product') === key ? '' : 'none';
    });

    syncWishlist(state.productHandle, card.getAttribute('data-finish-product-id'));
    syncProductInfoBlock(card.getAttribute('data-finish-title'), card.getAttribute('data-finish-short-desc'));
    /* renderProductGallery will replace the media wrapper — skip the immediate
       image swap to avoid a visible flash before the full re-render lands. */
    renderProductGallery(state.productHandle);

    updatePrice();
    updateAtc();
    /* advance defaults to true; pass false (e.g. the pre-selected default) to
       leave Step 1 open instead of jumping to Step 2. */
    if (advance !== false) openStep(2);
  }

  finishCards.forEach(function (card) {
    card.addEventListener('click', function () { selectFinishCard(card, true); });
  });

  /* ── Step 2: shade ─────────────────────────────────────── */
  function resetShade() {
    state.shadeVariantId = null;
    state.shadeCode = null;
    state.bundleVariant = null;
    root.querySelectorAll('.bundle__shade-swatch').forEach(function (s) { s.classList.remove('bundle__shade-swatch--active'); });
    if (shadeDescTxt) shadeDescTxt.innerHTML = '';
    if (shadeDescEl) shadeDescEl.classList.remove('bundle__shade-desc--visible');
  }

  root.addEventListener('click', function (e) {
    var swatch = e.target.closest('.bundle__shade-swatch');
    if (!swatch) return;

    root.querySelectorAll('.bundle__shade-swatch').forEach(function (s) { s.classList.remove('bundle__shade-swatch--active'); });
    swatch.classList.add('bundle__shade-swatch--active');
    state.shadeVariantId = swatch.getAttribute('data-variant-id');
    state.shadeCode = swatch.getAttribute('data-shade-code');

    var code = swatch.getAttribute('data-shade-code');
    var desc = swatch.getAttribute('data-shade-desc');
    if (shadeDescTxt) shadeDescTxt.innerHTML = '<strong>' + code + '</strong>' + (desc ? ' — ' + desc : '');
    if (shadeDescEl) shadeDescEl.classList.add('bundle__shade-desc--visible');

    setGalleryImage(swatch.getAttribute('data-shade-img'));
    resolveBundle();
    updatePrice();
    updateAtc();
    openStep(3);
  });

  /* ── Step 3: palette ───────────────────────────────────── */
  function selectPalette(card) {
    root.querySelectorAll('[data-palette-card]').forEach(function (c) { c.classList.remove('bundle__palette-card--active'); });
    card.classList.add('bundle__palette-card--active');
    state.paletteVariantId = card.getAttribute('data-variant-id');
    state.paletteTitle = card.getAttribute('data-palette-title');
    state.palettePriceCents = parseInt(card.getAttribute('data-palette-price-cents'), 10) || 0;
    resolveBundle();
    updatePrice();
    updateAtc();
    if (stepsDone() === 3) openStep(0); /* collapse so the ATC is in view */
  }

  root.addEventListener('click', function (e) {
    var card = e.target.closest('[data-palette-card]');
    if (card) selectPalette(card);
  });
  root.addEventListener('keydown', function (e) {
    var card = e.target.closest('[data-palette-card]');
    if (card && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      selectPalette(card);
    }
  });

  /* ── Add to cart ───────────────────────────────────────── */
  atcBtn.addEventListener('click', function () {
    if (atcBtn.disabled || !isComplete()) return;
    showError('');
    atcBtn.classList.add('bundle__atc-btn--loading');
    if (atcTextEl) atcTextEl.textContent = labels.adding;
    var qty = getQty();

    /* Bundle mode → add the single resolved bundle variant (Shopify expands it
       into its components as one line item). Otherwise add both variants. */
    var items = state.bundleVariant
      ? [{ id: parseInt(state.bundleVariant.id, 10), quantity: qty }]
      : [
          { id: parseInt(state.shadeVariantId, 10), quantity: qty },
          { id: parseInt(state.paletteVariantId, 10), quantity: qty },
        ];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description); });
        return r.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var triggers = ['[data-cart-drawer-trigger]', '[data-open-cart]', '.t4s-mini-cart-icon a', '[href="/cart"]'];
        for (var i = 0; i < triggers.length; i++) {
          var el = document.querySelector(triggers[i]);
          if (el) { el.click(); break; }
        }
        if (atcTextEl) atcTextEl.textContent = labels.added;
        setTimeout(function () { atcBtn.classList.remove('bundle__atc-btn--loading'); updateAtc(); }, 2500);
      })
      .catch(function (err) {
        atcBtn.classList.remove('bundle__atc-btn--loading');
        updateAtc();
        if (errorEl) {
          errorEl.textContent = (err && err.message) || 'Something went wrong.';
          errorEl.classList.add('bundle__error--visible');
        }
      });
  });

  /* ── Init ──────────────────────────────────────────────── */
  if (stepsExpanded) {
    stepEls.forEach(function (step) {
      setStepOpen(parseInt(step.getAttribute('data-bsp-step'), 10), true);
    });
  } else {
    openStep(1);
  }
  updateAtc();

  /* Pre-select a foundation when configured (and that card exists). */
  var defaultKey = root.getAttribute('data-default-product');
  if (defaultKey) {
    var defaultCard = root.querySelector('[data-finish-card="' + defaultKey + '"]');
    if (defaultCard) selectFinishCard(defaultCard, false);
  }
})();
